import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { PromptService } from 'src/app/services/prompt.service';
import { Subscription } from 'rxjs';
import { ForumService } from 'src/app/services/forum.service';
import { ProjectService } from 'src/app/services/project.service';
import { EventService } from 'src/app/services/event.service';
import { InstitutionService } from 'src/app/services/institution.service';
import { JobService } from 'src/app/services/job.service';
import { ToastService } from 'src/app/services/toast.service';
import { ResourceService } from 'src/app/services/resource.service';
import { UserService } from 'src/app/services/user.service';
import { LoadingService } from 'src/app/services/loading.service';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'oc-single-heading',
  templateUrl: './single-heading.component.html',
  styleUrls: ['./single-heading.component.scss'],
  host: {
    '(document:click)': 'onClick($event)',
  },
})
export class SingleHeadingComponent implements OnInit {
  @ViewChild('optionsEl', { static: false }) optionsEl: ElementRef;
  @Input() type: string;
  @Input() data: any;
  @Input() user: any;
  @Input() members = null;
  @Output() headingEvent: EventEmitter<any> = new EventEmitter();
  dataId;
  ownerId;
  membershipRequests = 0;
  userIsAdmin = false;
  member = false;
  optionsMenu = {
    expanded: false,
  };
  activatedTooltip = false;

  constructor(
    private router: Router,
    private promptService: PromptService,
    private toastService: ToastService,
    private forumService: ForumService,
    private projectService: ProjectService,
    private eventService: EventService,
    private institutionService: InstitutionService,
    private jobService: JobService,
    private resourceService: ResourceService,
    private userService: UserService,
    private loadingService: LoadingService,
    private notificationsService: NotificationsService
  ) { }

  ngOnInit() {
    if (this.data) {
      this.dataId = this.data.id;

      // Set ownerId
      if (this.type === 'member') {
        this.ownerId = this.data.uid;
      } else {
        this.ownerId = this.data.owner;
      }

      // Set userIsAdmin
      if (this.user.superuser || this.ownerId == this.user.uid || this.checkIfAdmin()) {
        this.userIsAdmin = true;
      }

      // Set member
      if (this.checkIfMember()) {
        this.member = true;
      }

      // Set membership requests
      if (this.type === 'institution' || this.type === 'project') {
        this.members.subscribe((m) => {
          if (m) {
            this.members = m;
            this.members.forEach((member) => {
              if (member[this.type + 'Roles'][this.data.id].status === 'pending') this.membershipRequests++;
            });
          }
        });
      }

      // Set tooltip
      if (this.type === 'discussion' && !this.user.followTooltip) {
        this.user.followTooltip = 0;
      }
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (!this.dataId) {
      if (this.data) this.dataId = this.data.id;
    }
  }
  checkIfAdmin() {
    let admin = false;
    if (this.type === 'institution' || this.type === 'project') {
      ['institution', 'project'].forEach((t) => {
        if (this.user[t + 'Roles'][this.data.id] && this.user[t + 'Roles'][this.data.id].role === 'admin') {
          admin = true;
        }
      });
    }
    return admin;
  }
  checkIfMember() {
    let member = false;
    if (this.type === 'institution' || this.type === 'project') {
      ['institution', 'project'].forEach((t) => {
        if (this.user[t + 'Roles'][this.data.id] && this.user[t + 'Roles'][this.data.id].status === 'active') {
          member = true;
        }
      });
    }
    return member;
  }

  follow() {
    if (!this.user.notificationSettings.followedDiscussions) {
      this.user.notificationSettings.followedDiscussions = [];
    }
    if (this.user.notificationSettings.followedDiscussions.indexOf(this.data.id) === -1) {
      this.user.notificationSettings.followedDiscussions.push(this.data.id);
      this.toastService.setToast(`<p class="mbn txt-c">You are now subscribed to this discussion</p>`);
    } else {
      const ind = this.user.notificationSettings.followedDiscussions.indexOf(this.data.id);
      this.user.notificationSettings.followedDiscussions.splice(ind, 1);
      this.toastService.setToast(`<p class="mbn txt-c">You are now unsubscribed from this discussion</p>`);
    }
    this.userService.saveUser(this.user.uid, this.user);
  }

  edit() {
    this.router.navigate(['/m/edit-' + (this.type === 'member' ? 'profile' : this.type)], {
      queryParams: { id: this.type === 'member' ? this.ownerId : this.data.id },
    });
  }
  delete() {
    const typeLabel = this.type.substring(0, 1).toUpperCase() + this.type.substring(1);

    this.promptService.setPrompt({
      hidden: false,
      heading: 'Are you sure you want to delete this ' + this.type + '?',
      body: 'You cannot undo this action.',
      confirmText: 'Delete ' + this.type,
      rejectText: 'Nevermind',
    });
    this.promptService.userResponse.subscribe((res) => {
      const service = (this.type === 'discussion' ? 'forum' : this.type) + 'Service';
      const deleteFunc = 'delete' + typeLabel;
      const roles = this.type + 'Roles';
      const url = this.type === 'discussion' ? 'forum' : this.type + 's';

      if (res === 'confirm') {
        this.loadingService.startLoading();

        // Call delete function from service.  Set up to work for any of the service types
        this[service][deleteFunc](this.data.id).then((deleteRes) => {
          // Remove IDs stored on user
          if (
            this.type === 'event' ||
            this.type === 'institution' ||
            this.type === 'project' ||
            this.type === 'discussion'
          ) {
            // Remove from array
            const type = this.type === 'discussion' ? 'comments' : this.type + 's';
            const i = this.user[type].indexOf(this.dataId);
            if (i !== -1) this.user[type].splice(i, 1);

            // For types that have roles, remove roles object
            if (this.type === 'institution' || this.type === 'project') {
              if (this.user[roles][this.dataId]) delete this.user[roles][this.dataId];
            }

            this.userService.saveUser(this.user.uid, this.user).then(() => {
              this.promptService.clearPrompt();
              this.loadingService.stopLoading();
              this.router.navigate(['/' + url]);
              this.toastService.setToast(
                `<p class="mbn txt-c">${this.type.charAt(0).toUpperCase() + this.type.substring(1)} deleted</p>`
              );
            });
          } else {
            this.promptService.clearPrompt();
            this.loadingService.stopLoading();
            this.router.navigate(['/' + url]);
            this.toastService.setToast(
              `<p class="mbn txt-c">${this.type.charAt(0).toUpperCase() + this.type.substring(1)} deleted</p>`
            );
          }
        });
      } else if (res === 'reject') {
        this.promptService.clearPrompt();
      }
    });
  }
  deleteUser() {
    this.promptService.setPrompt({
      hidden: false,
      heading: 'Are you sure you want to delete this user?',
      body: 'You cannot undo this action.',
      confirmText: 'Delete User',
      rejectText: 'Nevermind',
    });
    this.promptService.userResponse.subscribe((res) => {
      if (res === 'confirm') {
        this.loadingService.startLoading();

        this.data.banned = true;
        this.userService.saveUser(this.data.uid, this.data).then(() => {

          this.notificationsService.sendNotifications({
            type: 'accountDeleted',
            email: this.data.email,
          });

          this.promptService.clearPrompt();
          this.loadingService.stopLoading();
          this.router.navigate(['/members']);
          this.toastService.setToast(
            `<p class="mbn txt-c">${this.type.charAt(0).toUpperCase() + this.type.substring(1)} deleted</p>`
          );
        })


      } else if (res === 'reject') {
        this.promptService.clearPrompt();
      }
    })
  }
  archive() {
    const service = this.type + 'Service';
    const update = 'update' + this.type.charAt(0).toUpperCase() + this.type.substring(1);
    this.loadingService.startLoading();
    this.data.archived = true;
    this.optionsMenu.expanded = false;
    this[service][update](this.data.id, this.data).then(() => {
      this.loadingService.stopLoading();
      this.router.navigate(['/' + this.type + 's']);
      this.toastService.setToast(
        `<p class="mbn txt-c">${this.type.charAt(0).toUpperCase() + this.type.substring(1)} archived</p>`
      );
    });
  }
  unarchive() {
    const service = this.type + 'Service';
    const update = 'update' + this.type.charAt(0).toUpperCase() + this.type.substring(1);
    this.loadingService.startLoading();
    this.data.archived = false;
    this.data.autoArchiveOverride = true;
    this.optionsMenu.expanded = false;
    this[service][update](this.data.id, this.data).then(() => {
      this.loadingService.stopLoading();
      this.router.navigate(['/' + this.type + 's']);
      this.toastService.setToast(
        `<p class="mbn txt-c">${this.type.charAt(0).toUpperCase() + this.type.substring(1)} unarchived</p>`
      );
    });
  }

  flag() {
    this.notificationsService.sendNotifications({
      type: 'flag',
      content: this.type,
      url: window.location.href,
    });
    this.toastService.setToast(
      `<p class="mbn txt-c">${this.type.charAt(0).toUpperCase() + this.type.substring(1)} flagged.</p>`
    );
  }

  copyLink() {
    var el = document.createElement('textarea');
    el.value = window.location.href;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    this.toastService.setToast(`<p class="mbn txt-c">Link copied!</p>`);
  }

  onClick(event) {
    if (!this.optionsEl.nativeElement.contains(event.target)) {
      if (this.optionsMenu.expanded) this.optionsMenu.expanded = false;
    }
  }

  leave() {
    this.headingEvent.emit('leave');
    this.optionsMenu.expanded = false;
  }

  showTooltip() {
    if (!this.activatedTooltip) {
      this.user.followTooltip++;
      this.userService.saveUser(this.user.uid, this.user);
      this.activatedTooltip = true;
    }
  }
}